<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>已完成订单</span>
      </div>
      
      <el-alert
        title="提示：此处显示所有已完成的订单"
        type="success"
        :closable="false"
        style="margin-bottom: 20px"
      />

      <!-- 搜索区域 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="queryParams.orderNo" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="orderList">
        <el-table-column label="订单ID" align="center" prop="id" width="80" />
        <el-table-column label="订单号" align="center" prop="orderNo" width="180" />
        <el-table-column label="用户信息" align="center" prop="userName" width="120" />
        <el-table-column label="订单金额" align="center" prop="totalAmount" width="120" />
        <el-table-column label="完成时间" align="center" prop="completeTime" width="180" />
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CompletedOrders',
  data() {
    return {
      loading: true,
      total: 0,
      orderList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNo: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取已完成订单列表
      setTimeout(() => {
        this.orderList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleView(row) {
      this.$message.info('查看详情功能待实现')
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
